import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'getm-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class GetmOrderSummaryComponent implements OnInit, OnDestroy {

  @Input() totalBoxes = 0;
  @Input() pointsToWin = 0;
  @Input() savings = 0;
  @Input() totalToPay = 0;
  @Input() totalFavs = 0;
  @Input() isOrderConfirmed = false;
  @Input() isBonus = false;
  @Input() set deliveryDate(value: string) {
    this.deliveryDateTime = value || '';
    this.buildDisclaimers();
  }
  @Input() limitDate = '';

  public disclaimers: IDisclaimers[] = [];
  public deliveryDateTime: string = '';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.buildDisclaimers();
  }

  ngOnDestroy() {
  }

  public buildDisclaimers() {
    const disclaimers: IDisclaimers[] = this.translate.instant('Miscellaneous.list-disclaimers-summary-order');

    this.disclaimers = disclaimers.map(d => {
      if (!this.isOrderConfirmed) {
        return { ...d, active: d.id < 3 }
      }

      if (this.isBonus && d.id === 4) {
        return { ...d, active: true }
      }
      return d
    })
      .filter(d => d.active);
  }

}

interface IDisclaimers { id: number; icon: string; disclaimer: string; active: boolean; };
